module.exports = __webpack_public_path__ + "static/img/C (9).3907325d.png";